import React from 'react'
import Navbar from './Navbar'
import a1 from './images/a1.jpg'
import a6 from './images/a6.jpg'
import a7 from './images/a7.jpg'
import a8 from './images/a8.jpg'

const Services = () => {
    return (
        <div>
            <header id="site-header" class="fixed-top">
                <Navbar></Navbar>
            </header>

            <div class="inner-banner py-5">
                <section class="w3l-breadcrumb text-left py-sm-5 ">
                    <div class="container">
                        <div class="w3breadcrumb-gids">
                            <div class="w3breadcrumb-left text-left">
                                <h2 class="inner-w3-title">
                                    Services </h2>
                                <p class="inner-page-para mt-2">
                                    Growing your crops, growing your profits</p>
                            </div>
                            <div class="breadcrumb-right">
                                <ul class="breadcrumbs-custom-path">
                                    <li><a href="index.html">Home</a></li>
                                    <li class="active"><span class="fas fa-angle-double-right mx-2"></span> Services </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </section>
            </div>

            <section class="w3l-circles py-5" id="services">
                <div class="container py-md-5 py-2">
                    <div class="row w3l-circles">
                        <div class="col-lg-6 circles-left">
                            <img src={a6} alt="" class="radius-image img-fluid" />
                        </div>
                        <div class="col-lg-6 circles-right mt-lg-0 mt-5 align-self  position-relative">
                            <h6 class="title-subw3hny">what We Offer</h6>
                            <h3 class="title-w3l mb-4">Providing High
                                Quality <br></br> Products </h3>
                            <p class="">Lets Have a Look of what we have got to offer our Services to you with our high end advanced technologies and Algorithms.</p>
                            <div class="banner-content-btns">
                                <a href="about.html" class="btn btn-style btn-primary mt-lg-5 mt-4 me-2">Read More <i
                                    class="fas fa-arrow-right ms-2"></i></a>
                                <a href="contact.html" class="btn btn-style btn-outline-dark mt-lg-5 mt-4">Contact Us <i
                                    class="fas fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="w3l-content-4 py-5" id="features">
                <div class="content-4-main py-lg-5 py-md-4 py-2">
                    <div class="container">
                        <div class="content-info-in row align-items-center">
                            <div class="content-left col-lg-6 pe-lg-5">
                                <div class="row content4-right-grids mb-sm-5 mb-4 pb-3">
                                    <div class="col-2 content4-right-icon">
                                        <div class="content4-icon">
                                            <span class="fas fa-tractor"></span>
                                        </div>
                                    </div>
                                    <div class="col-10 content4-right-info ps-lg-5">
                                        <h6><a href="#url">Crop Reccomendation</a></h6>
                                        <p>Our crop recommendation model leverages advanced algorithms and data analytics to provide accurate and tailored suggestions for optimal crop selection.</p>
                                    </div>
                                </div>
                                <div class="row content4-right-grids mb-sm-5 mb-4 pb-3">
                                    <div class="col-2 content4-right-icon">
                                        <div class="content4-icon">
                                            <span class="fas fa-carrot"></span>
                                        </div>
                                    </div>
                                    <div class="col-10 content4-right-info ps-lg-5">
                                        <h6><a href="#url">Fertilizer Reccomendation</a></h6>
                                        <p>Our fertilizer recommendation model combines scientific expertise and data analysis to deliver precise recommendations, optimizing fertilizer usage for improved crop growth and sustainability.</p>
                                    </div>
                                </div>
                                <div class="row content4-right-grids">
                                    <div class="col-2 content4-right-icon">
                                        <div class="content4-icon">
                                            <span class="fas fa-wine-bottle"></span>
                                        </div>
                                    </div>
                                    <div class="col-10 content4-right-info ps-lg-5">
                                        <h6><a href="#url">Disease Prediction</a></h6>
                                        <p>Our disease prediction model utilizes cutting-edge technology and machine learning to proactively forecast and prevent crop diseases, ensuring healthier yields.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="HomeAboutImages col-lg-6 mt-lg-0 mt-md-5 mt-4">
                                <div class="row position-relative">
                                    <div class="col-6">
                                        <img src={a1} alt="" class="radius-image img-fluid" />
                                    </div>
                                    <div class="col-6 mt-4">
                                        <img src={a7} alt="" class="radius-image img-fluid mb-md-3 mb-2" />
                                        <img src={a8} alt="" class="radius-image img-fluid mt-md-3" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="w3l-index5 py-5" id="about">
                <div class="new-block py-md-5 py-3">
                    <div class="container">

                        <div class="row middle-section align-self">
                            <div class="col-lg-6 video-info pe-lg-5">
                                <div class="title-content text-left">
                                    <h6 class="title-subw3hny">Root With Nature</h6>
                                    <h3 class="title-w3l two pe-lg-5">For Strong economy, develop agriculture </h3>
                                    <a href="contact.html" class="btn btn-style btn-outline-light mt-sm-5 mt-4">Contact Now </a>
                                </div>
                            </div>
                            <div class="col-lg-6 history-info mt-5 ps-lg-5 align-self">
                                <p class="vhny-para mt-3 pe-lg-5">Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem
                                    ipsum dolor sit amet elit
                                    consec tetur adipisi elit.
                                    Lorem ipsum dolor sit amet elit consec tetur adipisi elit. Iure voluptatibus explicabo
                                    officia.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-features-4">
                <div class="features4-block py-5">
                    <div class="container py-md-5">
                        <div class="we-header text-center">
                            <h6 class="title-subw3hny">Our Services</h6>
                            <h3 class="title-w3l mb-5">What We’re Doing</h3>
                        </div>
                        <div class="row features4-grids">
                            <div class="col-lg-3 col-md-6">
                                <div class="features4-grid active">
                                    <div class="feature-images">
                                        <span class="fas fa-carrot"></span>
                                    </div>
                                    <h5><a href="#url">Fresh Vegetables</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-lg-0 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-tractor"></span>
                                    </div>
                                    <h5><a href="#url">Farm Products</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-lg-0 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-seedling"></span>
                                    </div>
                                    <h5><a href="#url">Organic Products</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-lg-0 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-bong"></span>
                                    </div>
                                    <h5><a href="#url">Awesome Wheats</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-apple-alt"></span>
                                    </div>
                                    <h5><a href="#url">Fresh Fruits</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-headphones-alt"></span>
                                    </div>
                                    <h5><a href="#url">
                                        Excellent Service</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-users"></span>
                                    </div>
                                    <h5><a href="#url">Qualified Staff</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 mt-4">
                                <div class="features4-grid">
                                    <div class="feature-images">
                                        <span class="fas fa-thumbs-up"></span>
                                    </div>
                                    <h5><a href="#url">Organic Solution</a></h5>
                                    <a href="#readmore" class="grid-link">Read More <span class="fa fa-arrow-right"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer class="w3l-footer-29-main">
                <div class="footer-29-w3l py-5">
                    <div class="container pt-md-5">
                        <div class="w3l-footer-text-style">
                            <div class="footer-list-cont d-sm-flex align-items-center justify-content-between mb-5">

                                <h2 class="w3logo"><a class="navbar-brand" href="index.html">
                                    Agrow<span class="sub-color">Grow</span>
                                </a></h2>
                                <div class="main-social-footer-29">
                                    <ul>
                                        <li><a href="https://facebook.com" class="facebook"><i
                                            class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="https://twitter.com" class="twitter"><i class="fab fa-twitter"></i></a>
                                        </li>
                                        <li><a href="https://instagram.com/_mayank_ahuja" class="instagram"><i
                                            class="fab fa-instagram"></i></a></li>
                                        <li><a href="#linkedin" class="linkedin"><i class="fab fa-linkedin-in"></i></a></li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div class="row footer-top-29 pt-lg-5 pt-sm-4">
                            <div class="col-lg-3 col-sm-6">
                                <div class="address-grid">
                                    <h5>VIT Bhopal University<br></br> Bhopal.</h5>
                                    <p class="mt-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                        tempor </p>

                                </div>
                            </div>
                            <div class="col-lg-3 col-sm-6 mt-sm-0 mt-4 ps-lg-5">
                                <div class="address-grid">
                                    <h5>Phone</h5>
                                    <h5 class="phone-number-text mt-2"><a href="tel:+91 8305682466">+91 8305682466</a></h5>
                                </div>
                                <div class="address-grid mt-sm-5 mt-4">
                                    <h5>E-mail</h5>
                                    <h5 class="email-cont-text mt-1"> <a href="mailto:mayankahuja451@gmail.com"
                                        class="mail">mayankahuja451@gmail.com</a></h5>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-sm-5 footer-list-menu ps-lg-5 mt-lg-0 mt-sm-5 mt-4">
                                <div class="address-grid">
                                    <h5 class="mb-4 pb-lg-2">Support</h5>
                                    <ul>
                                        <li><a href="#privacy">Privacy Policy</a></li>
                                        <li><a href="#terms"> Terms of Service</a></li>
                                        <li><a href="contact.html">Contact us</a></li>
                                        <li><a href="#faq">faQ</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div
                                class="address-grid col-lg-4 col-md-6 col-sm-7 ps-lg-5 mt-lg-0 mt-sm-5 mt-4 w3l-footer-16-main">
                                <h5>Subscribe here</h5>
                                <form action="#" class="subscribe d-flex mt-4 pt-lg-2 mb-4" method="post">
                                    <input type="email" name="email" placeholder="Email Address" required="" />
                                    <button><span class="fa fa-paper-plane" aria-hidden="true"></span></button>
                                </form>
                                <p>Subscribe to our mailing list and get updates to your email inbox.</p>
                            </div>
                        </div>
                        <div class="w3l-copyright text-center mt-lg-5 mt-sm-4 pt-md-4 pt-3">
                            <p class="copy-footer-29">© AgrowGrow. All rights reserved.
                                <a /></p>
                        </div>
                    </div>
                </div>
            </footer >
        </div >


    )
}

export default Services
